// pages/orders/index.tsx
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUser } from 'src/utils/user/user';
import ShipperOrders from './shipper/orders';
import EnforcementOrders from './enforcement/orders';

const OrdersPage = () => {
  const navigate = useNavigate();
  const user = useMemo(() => getUser(), []);

  if (!user) {
    navigate('/login');
    return null;
  }

  switch (user.type) {
    case 'superAdmin':
    case 'admin':
      return <EnforcementOrders />;
    case 'shipper':
      return <ShipperOrders />;
    case 'enforcement':
      return <EnforcementOrders />;
    default:
      return <div className="p-4 text-center text-lg text-danger mt-20">Unauthorized to view orders</div>;
  }
};

export default OrdersPage;